import { Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  subtitle?: string;
}

const AccordionTitle = (props: Props) => {
  return (
    <Stack direction="row" spacing={0.25}>
      <Typography variant="body2">{props.title}</Typography>
      <Typography variant="placeholder">{props.subtitle}</Typography>
    </Stack>
  );
};

export { AccordionTitle };
